module.exports = __webpack_public_path__ + "static/media/HCMM928.cfc1647b.jpg";